var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.getAllOrders}},[_vm._v("zamówienia")]),_c('pre',[_vm._v(_vm._s(_vm.ordersCsv))])])
}
var staticRenderFns = []

export { render, staticRenderFns }